// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar'; 
import HomePage from './pages/HomePage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ContactPage from './pages/ContactPage';

import WhatsApp from './components/Whatsapp'; 
import ServicePage from './pages/ServicePage';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hizmet/:slug" element={<ServiceDetailPage />} />
        <Route path="/hizmetler" element={<ServicePage/>}/>
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <WhatsApp />
    </BrowserRouter>
  );
}

export default App;